export const INVOICE_TYPE = 'Invoice';

export const QUOTE_TYPE = 'Quote';

export const VIEW = 'view';
export const NEW = 'new';
export const EDIT = 'edit';

export const OVERVIEW = 'overview';
export const PAYMENT = 'payment';
export const DELIVERY_NOTE = 'delivery-note';
export const LOG = 'log';



/** WEBPACK FOOTER **
 ** ./client/pages/invoice/constant.js
 **/